import React, { useContext } from "react";
import HomePage from "./pages/HomePage";
import StudentsContext from "./StudentsContext";

const App = () => {
  const students = useContext(StudentsContext);

  return (
    <div className="container">
      <HomePage students={students} />
    </div>
  );
};

export default App;
